import React, { useState } from "react";
import styles from "./styles.module.scss";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import { AlertBox } from "../../../../shared/AlertBox/AlertBox";
import { Textarea } from "../../../../shared/Textarea/Textarea";
import { CircularProgress } from "../../../../shared/CircularProgress/CircularProgress";
import { Button } from "../../../../shared/Button/Button";
import { isNullish } from "../../../../utilities/general";

/**
 * @param {{
 *   cannotSendReason?: string;
 *   messageCharLimit?: number;
 *   isLoading?: boolean;
 *   isSending?: boolean;
 *   onSend: (message: string) => void;
 *   renderTextarea?: (props: {
 *      value: string;
 *      onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
 *      placeholder: string;
 *      maxLength?: number;
 *      maxRows?: number;
 *      className?: string;
 *      isDisabled?: boolean;
 *   }) => React.ReactNode;
 *   footerAdornment?: React.ReactNode;
 * }} param0
 */
export const Footer = ({
  cannotSendReason,
  messageCharLimit,
  isLoading,
  isSending,
  onSend,
  renderTextarea,
  footerAdornment,
}) => {
  const { tCommon: t } = useAppTranslation.Common();
  const [message, setMessage] = useState("");

  const textareaProps = {
    value: message,
    onChange: (e) => setMessage(e.target.value),
    placeholder: t("chat.send.placeholder"),
    maxLength: messageCharLimit,
    maxRows: 5,
    className: styles.input,
    isDisabled: isLoading,
  };

  return (
    <div className={styles.root}>
      {cannotSendReason ? (
        <AlertBox size="small">{cannotSendReason}</AlertBox>
      ) : (
        <>
          <div className={styles.controls}>
            {renderTextarea?.(textareaProps) || <Textarea {...textareaProps} />}
            <Button
              className={styles.send}
              onClick={() => onSend(message).then(() => setMessage(""))}
              isDisabled={isSending || isLoading || !message.trim()}
              leftAdornment={
                isSending ? (
                  <CircularProgress size="tiny" color="white" />
                ) : undefined
              }
            >
              {t("chat.send.submit")}
            </Button>
          </div>
          {!isNullish(messageCharLimit) && (
            <div className={styles.charLimit}>
              {message.length} / {messageCharLimit}
            </div>
          )}
          {footerAdornment}
        </>
      )}
    </div>
  );
};
